
export default {
  props: {
    videoid: "",
    playlabel: "",
  },
};
